<!--
 * @Description: 
 * @Date: 2021-11-08 11:09:50
-->
<template>
  <el-dialog
    class="chartDia"
    :show-close="true"
    :close-on-click-modal="false"
    @close="close"
    :visible="true"
    width="580px"
    ref="upload"
    v-loading="loading"
  >
    <div slot="title" class="aspTit">上传附件</div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <el-form-item prop="folderName" label="文件夹名称：">
        <el-input
          placeholder="最多输入15个字"
          v-model="ruleForm.folderName"
          maxlength="15"
          show-word-limit
          style="width:400px;"
        />
      </el-form-item>
    </el-form>
    <el-upload
      class="asp-upload"
      :headers="headers"
      accept=".zip, .rar, .xls, .xlsx, .doc, .docx, .ppt, .pptx, .pdf, .png, .jpg"
      :action="protocolService.agreementServicesContractUpload"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :before-upload="beforeUp"
      :on-success="onSuccess"
      :on-error="onError"
      :on-change="changeFile"
      multiple
      :limit="limitCount"
      :on-exceed="handleExceed"
      :file-list="fileList"
    >
      <el-button
        size="small"
        class="uploadBox"
        type="primary"
        icon="el-icon-upload2"
      >
        点击上传
      </el-button>
      <div slot="tip" class="el-upload__tip">
        <p>
          支持附件：zip / rar / xls / xlsx / doc / docx / ppt /pptx / pdf / png
          / jpg
        </p>
        <p>最大支持上传50M文件</p>
      </div>
    </el-upload>
    <div class="btnBox">
      <el-button type="primary" plain @click="close">取消</el-button>
      <el-button type="primary" @click="submit" :loading="btLoading">
        提交
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { protocolService } from '@/api/ajax';
import { getToken } from '@/tools/auth';
import Config from '@/config/index';
import { btLoading } from '@/Mixin/btLoading';
export default {
  mixins: [btLoading],
  data() {
    return {
      loading: false,
      protocolService,
      fileList: [],
      ruleForm: {
        folderName: ''
      },
      rules: {
        folderName: [
          {
            required: true,
            trigger: 'change',
            message: '文件夹名称不能为空'
          }
        ]
      },
      headers: {
        [Config.token]: getToken()
      }
    };
  },
  props: {
    folderName: {
      type: String
    },
    itemData: {
      type: Object,
      default() {
        return {
          cou: 0
        };
      }
    },
    // 刷新父级列表方法
    listFn: {
      type: Function,
      default() {
        return () => {};
      }
    }
  },
  computed: {
    limitCount() {
      return 6 - this.itemData.cou;
    }
  },
  watch: {
    folderName: {
      immediate: true,
      handler(v) {
        if (v) {
          this.ruleForm.folderName = v;
        }
      }
    }
  },
  methods: {
    beforeUp(file) {
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error('上传文件大小不得超过50M');
        return false;
      }
      this.loading = true;
    },
    onSuccess() {
      this.loading = false;
    },
    onError() {
      this.loading = false;
    },
    handleRemove() {},
    handlePreview() {},
    handleExceed(files) {
      this.$message.warning(
        `最多支持上传${this.limitCount}个文件，本次选择了 ${files.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      this.fileList = fileList;
    },
    changeFile(file, fileList) {
      this.fileList = fileList;
    },
    close() {
      this.$emit('close');
    },
    submit() {
      if (this.fileList.length === 0) {
        this.$notify({
          title: '警告',
          message: '请至少上传一个文件',
          type: 'warning'
        });
      } else {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            this.SET_BTLOADING(true);
            let fileUrls = '';
            let fileNames = '';
            this.fileList.filter(item => {
              fileUrls += `${item.response.data},`;
              fileNames += `${item.name},`;
            });
            fileUrls = fileUrls.substr(0, fileUrls.length - 1);
            fileNames = fileNames.substr(0, fileNames.length - 1);
            let obj = {
              ...this.itemData,
              fileUrls,
              fileNames,
              ...this.ruleForm
            };
            protocolService.submitUploadFile(obj).then(() => {
              this.$notify({
                title: '成功',
                message: '上传成功',
                type: 'success'
              });
              this.SET_BTLOADING(false);
              this.listFn && this.listFn();
              this.close();
            });
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.aspTit {
  padding-top: 40px;
  font-size: 24px;
  line-height: 1;
  font-weight: bold;
  text-align: center;
}
.uploadBox {
  height: 68px;
  margin-top: 20px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 16px;
  i {
    font-size: 21px;
    color: #fff;
    margin-right: 12px;
    line-height: 68px;
  }
}
p {
  color: #696969;
  font-size: 12px;
  line-height: 1;
  margin-bottom: 16px;
  text-align: left;
}
</style>
<style lang="scss">
.asp-upload {
  .el-upload {
    width: 100%;
  }
  .uploadBox {
    width: 100%;
    i {
      font-size: 21px;
      color: #fff;
      margin-right: 12px;
    }
  }
  .el-upload-list {
    margin: auto;
    width: 517px;
    li {
      background: #eef6ff;
      margin-bottom: 20px;
    }
  }
}
</style>
